export default "__VITE_ASSET__BM9xjOdY__"